export const cancelAction= (data) => { 
    return {
       type: data.type,
       data:data.data
    }
 }